export function formatWorkshopRosterMessage(
  visibleNames: string[],
  namesHiddenCount: number,
  confirmedCount: number,
  workshopStarted: boolean
): string {
  if (confirmedCount === 0) {
    return 'No confirmed participants yet.';
  }

  if (visibleNames.length === 0) {
    const people =
      namesHiddenCount === 1 ? '1 person has' : `${namesHiddenCount} people have`;
    return `${people} confirmed and will be joining${
      workshopStarted ? '' : ' when the workshop starts'
    }.`;
  }

  let text = `Confirmed participants include ${visibleNames.join(', ')}`;
  if (namesHiddenCount > 0) {
    const other =
      namesHiddenCount === 1 ? '1 other person' : `${namesHiddenCount} other people`;
    text += `, + ${other} who will be joining`;
  }
  return `${text}.`;
}
